import React, { useEffect, useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';

export default function LoginToggle() {
  const [user, setUser] = useState(
    window.location.pathname.toLocaleLowerCase() == '/loginasinstitution' ? 'institutionLogin' : 'teacherLogin');

  const isMobile = useMediaQuery({ query: `(max-width: 769px)` });

  const history = useHistory();
  useEffect(() => {
    let user = window.localStorage.getItem('userType');
    if (window.location.pathname === '/LoginAsInstitution' && user === "teacherLogin") {
      history.push("/Login")
    } else if (window.location.pathname === '/Login' && user === "institutionLogin") {
      history.push("/LoginAsInstitution")
    }}
  ,[]);

  const handleChange = (e, newUser) => {
    if (newUser !== null) {
      window.localStorage.setItem('userType', newUser);
      setUser(newUser)
    }
  };

  const toggleButtonStyleLargeScreen = {fontSize: "26px", textTransform: "none", width: "170px", height: "70px",
    color: "#79cbca", border: "1px solid #79cbca", lineHeight: "normal", textAlign: "center"}
  const toggleButtonStyleSmallScreen = {fontSize: "26px", textTransform: "none", width: "170px", height: "70px",
    color: "white", border: "1px solid #79cbca", lineHeight: "normal", textAlign: "center"}

  return (
    <ToggleButtonGroup
      value={user}
      exclusive
      onChange={handleChange}
    >
      <ToggleButton
        style={isMobile ? toggleButtonStyleSmallScreen : toggleButtonStyleLargeScreen}
        className={user === 'teacherLogin' ? "btn-primary text-white" : "secondary-button-no-margin-hover"}
        href='/Login'
        value="teacherLogin">
        Teacher
      </ToggleButton>
      <ToggleButton
        style={isMobile ? toggleButtonStyleSmallScreen : toggleButtonStyleLargeScreen}
        className={user === 'institutionLogin' ? "btn-primary text-white" : "secondary-button-no-margin-hover"}
        href='/LoginAsInstitution'
        value="institutionLogin">
        Institution /
        Provider
      </ToggleButton>
    </ToggleButtonGroup>
  );
}